<template>
  <div>
    <div class="home-container">
      <div class="home-header">
        <div class="home-header-left">
          <router-link to="/home/set" tag="div">
            <div class="iconfont set-icon">&#xe636;</div>
          </router-link>
        </div>
        <!-- {{localStorage.username}} -->
        <div class="home-header-center">欢迎您,{{getUsername}}</div>
        <div class="home-header-right">
          <div class="iconfont clock-icon">&#xe633;</div>
        </div>
      </div>
      <div class="home-main">
        <div class="home-avatar">
          <van-image :src="IMG_PATH + '/logo.jpg'">
            <template v-slot:loading>
              <van-loading type="spinner" size="20"/>
            </template>
          </van-image>
        </div>
      </div>
      <div class="home-footer">
        <div class="home-data">
          <div class="home-data-num">{{info.ordercount}}</div>
          <div class="home-data-text">我的订单</div>
        </div>
        <router-link tag="div" to="/home/order/sum" class="home-data">
          <div class="home-data-num">{{info.currdaySummary}}</div>
          <div class="home-data-text">订单汇总</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {IMG_PATH} from '@/source'
export default {
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    getUsername() {
      return localStorage.username;
    },
    IMG_PATH() {
      return IMG_PATH
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@style/varibles.styl';

.home-container {
  width: 100%;
  height: 6.7rem;
  background: #e83b56;
  color: #fff;

  .home-header {
    height: $headerHeight;
    display: flex;

    .home-header-left, .home-header-right {
      width: 1rem;
      text-align: center;
    }

    .home-header-center {
      flex: 1;
      line-height: $headerHeight;
      text-align: center;
      font-size: 0.32rem;
    }

    .iconfont {
      height: 100%;
      line-height: $headerHeight;
      font-size: 0.5rem;
    }
  }

  .home-avatar {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0.6rem auto 0.5rem auto;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home-avatar img {
    max-width: 100%;
  }

  .home-footer {
    display: flex;
    position: relative;
    height: 2rem;
    justify-content: space-between;
    align-items: center;

    .line {
      width: 1px;
      background: #fff;
      height: 1.5rem;
    }

    .home-data {
      text-align: center;
      font-size: 0.28rem;
      flex: 1;
      line-height: 1.6;

      .home-data-num {
        font-family: Arial;
        font-size: 0.5rem;
      }
    }
  }
}
</style>
